import React from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import "./TextPage.css";
import ThemeContent from "./theme_content";
import axios from "axios";
import { baseURL } from "../Config/Config";
import Mundareja from "./Mundareja/Mundareja";

export default function TextPage() {

  let { id } = useParams();
  let { sub_id } = useParams();
  const [themes, setThemes] = React.useState();
  const [testId, setTestId] = React.useState();
  const [subjectName, setSubjectName] = React.useState();
  const [authorSub, setAuthorSub] = React.useState();
  const [current_theme, setCurrrent_theme] = React.useState(1);
  React.useEffect(() => {
    const source = axios.CancelToken.source();
    axios
      .get(`${baseURL}rtr_base_app/subject-list/${sub_id}/`, { cancelToken: source.token })
      .then((response) => {
        setThemes(response.data.themes);
        setTestId(response.data.tests[0]);
        setCurrrent_theme(response.data.themes[0].id)
        setSubjectName(response.data.title)
        setAuthorSub(response.data.author)

      })
      .catch((err) => {
        if (axios.isCancel(err)) {

        } else {
          console.log(err);
        }
      });
    return () => {
      source.cancel(`Request cancelled for subject with ID ${sub_id}.`);
    };
  }, [sub_id]);


  if (!themes) return null;
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="text-name">
          <h1>{subjectName}</h1>
        </div>
        <div className="left">
          <Link to="/" className="bosh">
            Bosh sahifa
          </Link>
          <Link to={`/boshlangich/${id}`} className="left-material bosh">
            Boshlang’ich kasbiy ta’lim
          </Link>
          <div className="author">
            {authorSub ? <a target='_blank' className="active" href={authorSub.file}> Mualliflar nomi</a> : null}
          </div>
        </div>
        <div className="text-box">
          <Mundareja
            subject_id={sub_id}
            themes={themes}
            testId={testId}
            setCurrrent_theme={setCurrrent_theme}
          />
          <ThemeContent current_theme={current_theme} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
